<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g transform="translate(-.816 -.816)" fill="none" stroke="#840000" stroke-width="1.5">
      <circle cx="7" cy="7" r="7" transform="translate(1.815 1.815)"/>
      <path d="m3.74 3.74 9.548 9.548"/>
    </g>
  </svg>
</template>
